import {
  AfterViewInit,
  ApplicationRef,
  Component,
  ComponentRef,
  EnvironmentInjector,
  Injector,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  createComponent,
  inject,
} from "@angular/core";
import {
  PucxModalAlertComponent,
  PucxModalConfig,
  PucxModalAlertConfig,
  PucxModalComponent,
  PucxModalRef,
  PucxModalService,
} from "@pucomex-ng-infra/pucx-components";
// import { UsuarioService } from "../../services/usuario.service";
import { Subject, take } from "rxjs";
// import { DOCUMENT } from "@angular/common";

declare var Plataforma;

@Component({
  selector: "classif-captcha",
  templateUrl: "./captcha.component.html",
  styleUrls: ["./captcha.component.css"],
  /**
   * ViewEncapsulation.None permite Q estilos sejam executados dentro do template HTML
   * https://stackoverflow.com/questions/44210786/style-not-working-for-innerhtml-in-angular
   */
  // encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class CaptchaComponent implements AfterViewInit {
  private readonly injector = inject(Injector);
  private readonly environmentInjector = inject(EnvironmentInjector)
  private readonly app = inject(ApplicationRef)
  // private readonly document = inject(DOCUMENT);
  // private readonly usuarioService = inject(UsuarioService);
  private readonly modalService = inject(PucxModalService);
  private readonly hostRef = inject(ViewContainerRef)
  private modalRef: PucxModalRef;
  private closed$: Subject<unknown>;

  @ViewChild("captchaTemplate", { static: true })
  public captchaTemplate!: TemplateRef<any>;

  ngAfterViewInit(): void {
    // if (this.usuarioService.isAcessoPublico) {
    if (this.isRequired) {
      // this.showModalCaptcha();
      this.createModalCaptcha();

      setTimeout(() => {
        Plataforma.getInstance().initCaptcha(
          true,
          ["PUBLICO"],
          () => {
            this.modalRef.close(true);
          },
        );
      }, 500);
    }
  }

  private showModalCaptcha() {
    this.modalService.alert({
      title: "Captcha",
      content: this.captchaTemplate,
      severity: "info",
      button: false,
      persistent: true,
    });
  }

  public logout() {
    Plataforma.getInstance().logout();
  }

  private get isRequired() {
    return Plataforma.getInstance().isRequiredCaptcha(["PUBLICO"]);
  }

  // Criação passo a passo para ter acesso a um modalRef e poder fechar APENAS o modal do Captcha
  private createModalCaptcha() {
    this.closed$ = new Subject<unknown>();
    this.modalRef = new PucxModalRef(this.closed$);

    const config: PucxModalAlertConfig = {
      title: "Captcha",
      content: this.captchaTemplate,
      persistent: true,
      focusOnShow: true,
      button: false,
      severity: "info",
      draggable: false,
      hasYScroll: false,
    }

    const elementInjector = Injector.create({
      providers: [
        { provide: PucxModalConfig, useValue: config },
        { provide: PucxModalRef, useValue: this.modalRef },
      ],
      parent: this.injector,
    });

    const modalComponentRef: ComponentRef<PucxModalComponent> = createComponent(PucxModalComponent, {
      environmentInjector: this.environmentInjector,
      elementInjector,
      hostElement: this.hostRef.element.nativeElement,
    });

    modalComponentRef.instance.childComponentType = PucxModalAlertComponent;

    // this.document.body.appendChild(modalComponentRef.location.nativeElement);

    this.app.attachView(modalComponentRef.hostView);

    this.closed$.pipe(take(1)).subscribe(() => {
      this.app.detachView(modalComponentRef.hostView);
      modalComponentRef.destroy();
    });
  }

}
